import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { AutoFocusModule } from 'primeng/autofocus';


import { injectNgControl } from '@core/helpers';
import { NoopValueAccesorDirective, OnlyNumbers2Directive, UpperCase2Directive } from '@shared/directives';


@Component({
  selector: 'prime-input',
  standalone: true,
  hostDirectives: [NoopValueAccesorDirective],
  imports: [
    NgClass,
    ReactiveFormsModule,
    InputTextModule,
    AutoFocusModule,
    OnlyNumbers2Directive,
    UpperCase2Directive,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './prime-input.component.html',
  styleUrl: './prime-input.component.scss'
})
export class PrimeInputComponent {
  /** señales para habilitar las directivas */
  upperCase = input(false);
  onlyNumbers = input(false);

  /** señales para los elementos del input HTML */
  inputId = input<string>();
  type = input<'text' | 'email' | 'password' | 'tel'>('text');
  classes = input<string>();
  placeholder = input<string>();
  disabled = input<boolean>();
  minLength = input<number>();
  maxLength = input<number>();
  autofocus = input(false);


  /** Variable para la injección de formularios reactivos en Angular */
  ngControl = injectNgControl();
}
